export default "__VITE_PUBLIC_ASSET__10763084__"